import {hiddenCloudProfileTypes} from '../../../utils/featureToggles'

export const hiddenCloudTypes: ReadonlyArray<string> | null =
  hiddenCloudProfileTypes != null && hiddenCloudProfileTypes.length > 0
    ? hiddenCloudProfileTypes.split(',')
    : null
